// Auto Translated 20221025-172022
const SINHALA_DICTIONARY = {
  "(1928 - 1946) Silent Generation": "(1928 - 1946) නිහඬ පරම්පරාව",
  "(1946 - 1965) Baby Boomers": "(1946 - 1965) ළදරු බූමර්ස්",
  "(1965 - 1981) Generation X": "(1965 - 1981) X පරම්පරාව",
  "(1981 - 1997) Millenials/Gen Y": "(1981 - 1997) Millenials/Gen Y",
  "10 - 20%": "10 - 20%",
  "20 - 30": "20 - 30",
  "20 - 30%": "20 - 30%",
  "25 - 30": "25 - 30",
  "30 - 35": "30 - 35",
  "30 - 40": "30 - 40",
  "30 - 40%": "30 - 40%",
  "35 - 40": "35 - 40",
  "40 - 45": "40 - 45",
  "40 - 50": "40 - 50",
  "40 - 50%": "40 - 50%",
  "45 - 50": "45 - 50",
  "50 - 55": "50 - 55",
  "50 - 60": "50 - 60",
  "50 - 60%": "50 - 60%",
  "55 - 60": "55 - 60",
  "60 - 65": "60 - 65",
  "60 - 70": "60 - 70",
  "60 - 70%": "60 - 70%",
  "65 - 70": "65 - 70",
  "70 - 75": "70 - 75",
  "70 - 80": "70 - 80",
  "70 - 80%": "70 - 80%",
  "75 - 80": "75 - 80",
  "80 - 85": "80 - 85",
  "80 - 90": "80 - 90",
  "80 - 90%": "80 - 90%",
  "85 - 90": "85 - 90",
  "90 - 100%": "90 - 100%",
  "@ParliamentLK": "@පාර්ලිමේන්තුවLK",
  "@TISriLanka": "@TISriLanka",
  "@nuuuwan": "@nuuuwan",
  "A. Aravindh": "A. අරවින්ද්",
  "A. Aravindh Kumar": "A. අරවින්ද් කුමාර්",
  "A. L. M.": "ඒ.එල්.එම්.",
  "A. L. M. Athaullah": "A. L. M. Athaullah",
  "A. Levels Or Higher": "උසස් පෙළ හෝ ඉහළ",
  ACMC: "ACMC",
  AITC: "AITC",
  Abdul: "අබ්දුල්",
  "Abdul Haleem": "අබ්දුල් හලීම්",
  Abegunawardhana: "අබේගුණවර්ධන",
  Abeysinghe: "අබේසිංහ",
  Abeywardana: "අබේවර්ධන ය",
  "Academic Qualifications": "අධ්යාපන සුදුසුකම්",
  Academician: "ශාස්ත්රාලිකයා",
  Accountant: "ගණකාධිකාරී",
  Adaikkalanathan: "අඩක්කලනාදන්",
  Age: "වයස",
  "Age > 40": "වයස > 40",
  "Age > 50": "වයස > 50",
  "Age Group (10 year)": "වයස් කාණ්ඩය (අවුරුදු 10)",
  "Age Group (5 year)": "වයස් කාණ්ඩය (අවුරුදු 5)",
  "Age ≤ 40": "වයස ≤ 40",
  "Age ≤ 50": "වයස ≤ 50",
  Agriculturist: "කෘෂිකාර්මික",
  Ahamed: "අහමඩ්",
  Ajith: "අජිත්",
  "Ajith Mannapperuma": "අජිත් මාන්නප්පෙරුම",
  "Ajith Rajapakse": "අජිත් රාජපක්ෂ",
  Akila: "අකිල",
  "Akila Ellawala": "අකිල එල්ලාවල",
  Alagiyawanna: "අලගියවන්න",
  Alahapperuma: "Alahapperuma",
  Alawathuwala: "අලවතුවල",
  "Ali Sabri": "අලි සබ්රි",
  "Ali Sabri Raheem": "අලි සබ්රි රහීම්",
  "Ali Sabry": "අලි සබ්රි",
  "All 100%": "සියලුම 100%",
  "All data except asset declaration data is from www.parliament.lk": "වත්කම් ප්‍රකාශන දත්ත හැර අනෙකුත් සියලුම දත්ත www.parliament.lk වෙතින් වේ",
  Alles: "අලස්",
  Aluthgamage: "අලුත්ගමගේ",
  Amal: "අමල්",
  Amarakeerthi: "අමරකීර්ති",
  "Amarakeerthi Athukorala": "අමරකීර්ති අතුකෝරල",
  Amarasena: "Amarasena",
  Amarasuriya: "අමරසූරියයි",
  Amaraweera: "අමරවීර",
  Amunugama: "අමුණුගම",
  Angajan: "අංගජන්",
  "Angajan Ramanathan": "අංගජන් රාමනාදන්",
  Anupa: "අනුප",
  "Anupa Pasqual": "අනුප පැස්කුවල්",
  Anura: "අනුර",
  "Anura Dissanayaka": "අනුර දිසානායක",
  "Anura Priyadharshana": "අනුර ප්‍රියදර්ශන",
  "Anura Priyadharshana Yapa": "අනුර ප්‍රියදර්ශන යාපා",
  Anuradha: "අනුරාධ",
  "Anuradha Jayaratne": "අනුරාධ ජයරත්න",
  Anuradhapura: "අනුරාධපුර",
  "App & Visualization by": "යෙදුම සහ දෘශ්‍යකරණය",
  Appuhamy: "අප්පුහාමි",
  Arachchi: "ආරච්චි",
  Arambepola: "අරඹේපොල",
  Arasan: "අරසන්",
  Arundika: "අරුන්දික",
  "Arundika Fernando": "අරුන්දික ප්‍රනාන්දු",
  Asanka: "අසංක",
  "Asanka Navarathna": "අසංක නවරත්න",
  Ashok: "අශෝක්",
  "Ashok Abeysinghe": "අශෝක් අබේසිංහ",
  Ashoka: "Ashoka",
  "Ashoka Priyantha": "අශෝක ප්‍රියන්ත",
  "Asset declaration data is from www.tisrilanka.org": "වත්කම් ප්‍රකාශන දත්ත www.tisrilanka.org වෙතින් වේ",
  Athaullah: "අතාවුල්ලාය",
  Athukorala: "අතුකෝරල",
  Athuraliye: "අතුරලියේ",
  "Athuraliye Rathana": "අතුරලියේ රතන",
  Attanayake: "අත්තනායක",
  "Attandance 8th Parliament (2017 - 2020)": "පැමිණීම 8 වැනි පාර්ලිමේන්තුව (2017 - 2020)",
  "Attandance 9th Parliament (2020 - )": "පැමිණීම 9 වැනි පාර්ලිමේන්තුව (2020 - )",
  "Attorney-at-Law": "නීතීඥ",
  "B. Y. G.": "බී. වයි. ජී.",
  "B. Y. G. Rathnasekara": "B. Y. G. රත්නසේකර",
  "Bachelors Or Higher": "උපාධිය හෝ ඊට වැඩි",
  Badulla: "බදුල්ල",
  "Bakeer Markar": "බාකීර් මාකර්",
  Balasuriya: "බාලසූරියයි",
  Bandara: "බණ්ඩාර ය",
  Bandula: "බන්දුල",
  "Bandula Gunawardana": "බන්දුල ගුණවර්ධන",
  "Bank Officer": "බැංකු නිලධාරියා",
  "Basil Rohana": "බැසිල් රෝහණ",
  "Basil Rohana Rajapaksa": "බැසිල් රෝහණ රාජපක්ෂ",
  Bathiudeen: "බදියුදීන්",
  Batticaloa: "මඩකලපුව",
  "Below A. Levels": "උසස් පෙළට පහළින්",
  "Below Bachelors": "උපාධියට පහළින්",
  Berugoda: "Berugoda",
  Buddhika: "බුද්ධික",
  "Buddhika Pathirana": "බුද්ධික පතිරණ",
  Buddhism: "බුද්ධාගම",
  Businessman: "ව්යාපාරිකයා",
  "Businessman/Managing Director": "ව්යාපාරික / කළමනාකාර අධ්යක්ෂ",
  "C. B.": "සී.බී.",
  "C. B. Rathnayake": "සී බී රත්නායක",
  "C.V.": "CV.",
  "C.V. Wigneswaran": "CV. විග්නේෂ්වරන්",
  Cassim: "කැසිම්",
  Central: "මධ්යම",
  Chamal: "චමල්",
  "Chamal Rajapaksa": "චමල් රාජපක්ෂ",
  "Chamara Sampath": "චාමර සම්පත්",
  "Chamara Sampath Dasanayake": "චාමර සම්පත් දසනායක",
  Chaminda: "චමින්ද",
  "Chaminda Wijesiri": "චමින්ද විජේසිරි",
  Chanaka: "චානක",
  Chandima: "චන්දිම",
  "Chandima Weerakkody": "චන්දිම වීරක්කොඩි",
  Chandrasena: "චන්ද්‍රසේන",
  Channa: "චන්න",
  "Channa Jayasumana": "චන්න ජයසුමන",
  Charitha: "චරිතා",
  "Charitha Herath": "චරිත හේරත්",
  Charles: "චාල්ස්",
  "Charles Nirmalanathan": "චාල්ස් නිර්මලනාදන්",
  "Christianity (All)": "ක්රිස්තියානි ධර්මය (සියල්ල)",
  "Civil Engineer": "සිවිල් ඉංජිනේරුවා",
  "Civil Status": "සිවිල් තත්වය",
  Code: "කේතය",
  Colombo: "කොළඹ",
  "Company Chairman": "සමාගමේ සභාපති",
  "Company Director": "සමාගම් අධ්යක්ෂ",
  "Consultant Economist": "උපදේශක ආර්ථික විද්යාඥ",
  "Contact Details": "ඇමතුම් විස්තර",
  Cumaratunga: "කුමාරතුංග ය",
  "D.": "ඩී.",
  "D. B.": "ඩී.බී.",
  "D. B. Herath": "ඩී බී හේරත්",
  "D. V.": "ඩී.වී.",
  "D. V. Chanaka": "D. V. චානක",
  "D. Weerasingha": "ඩී වීරසිංහ",
  Dasanayake: "දසනායක",
  "Data - The Parliament of Sri Lanka": "දත්ත - ශ්‍රී ලංකා පාර්ලිමේන්තුව",
  "Data - Transparency International - Sri Lanka": "දත්ත - ට්‍රාන්ස්පේරන්සි ඉන්ටර්නැෂනල් - ශ්‍රී ලංකාව",
  "Data from": "දත්ත",
  "Date of Birth": "උපන්දිනය",
  Dayasiri: "දයාසිරි",
  "Dayasiri Jayasekara": "දයාසිරි ජයසේකර",
  "De Silva": "ද සිල්වා",
  Declared: "ප්‍රකාශ කළා",
  Demographics: "ජනවිකාස",
  Denipitiya: "දෙනිපිටිය",
  "Dental Surgeon": "දන්ත ශල්ය වෛද්ය",
  Devananda: "දේවානන්දයි",
  "Dhammika Perera": "ධම්මික පෙරේරා",
  Dharmalingam: "ධර්මලිංගම්",
  "Dharmalingam Sithadthan": "ධර්මලිංගම් සිතද්දන්",
  Dharmasena: "ධර්මසේන",
  Dhileeban: "දිලීබන්",
  Diana: "ඩයනා",
  "Diana Gamage": "ඩයනා ගමගේ",
  "Did Not Vote: Absent": "ඡන්දය දුන්නේ නැත: නොපැමිණීම",
  "Did Not Vote: Not MP": "ඡන්දය දුන්නේ නැත: මන්ත්‍රී නොවේ",
  "Did Not Vote: Speaker": "ඡන්දය දුන්නේ නැහැ: කථානායක",
  Digamadulla: "දිගාමඩුල්ල",
  Dilan: "ඩිලාන්",
  "Dilan Perera": "ඩිලාන් පෙරේරා",
  Dilip: "දිලිප්",
  "Dilip Wedaarachchi": "දිලිප් වෙදආරච්චි",
  Dilum: "දිලුම්",
  "Dilum Amunugama": "දිලුම් අමුණුගම",
  Dinesh: "දිනේෂ්",
  "Dinesh Gunawardena": "දිනේෂ් ගුණවර්ධන",
  Dissanayaka: "දිසානායක",
  Dissanayake: "දිසානායක",
  Divorced: "දික්කසාද විය",
  Dodangoda: "දොඩන්ගොඩ",
  Dolawatte: "දොලවත්ත",
  Douglas: "ඩග්ලස්",
  "Douglas Devananda": "ඩග්ලස් දේවානන්ද",
  Dullas: "ඩලස්",
  "Dullas Alahapperuma": "ඩලස් අලහප්පෙරුම",
  Duminda: "දුමින්ද",
  "Duminda Dissanayake": "දුමින්ද දිසානායක",
  Dushmantha: "දුෂ්මන්ත",
  EPDP: "ඊ.පී.ඩී.පී",
  Eastern: "නැගෙනහිර",
  Economist: "ආර්ථික විද්යාඥ",
  Edirimanna: "එදිරිමාන්න",
  "Education & Profession": "අධ්‍යාපනය සහ වෘත්තිය",
  "Electoral District": "මැතිවරණ දිස්ත්රික්කය",
  "Electoral Districts": "මැතිවරණ දිස්ත්රික්ක",
  "Electoral Regions": "මැතිවරණ කලාප",
  Ellawala: "එල්ලාවල",
  Email: "විද්යුත් තැපෑල",
  Engineer: "ඉංජිනේරු",
  Eran: "එරන්",
  "Eran Wickramaratne": "එරාන් වික්‍රමරත්න",
  "External References": "බාහිර යොමු කිරීම්",
  Faizal: "ෆයිසාල්",
  "Faizal Cassim": "ෆයිසාල් කැසිම්",
  Faleel: "ෆලීල්",
  Farming: "ගොවිතැන් කරනවා",
  Female: "ගැහැණු",
  Fernando: "ප්‍රනාන්දු",
  Fernandopulle: "ප්‍රනාන්දුපුල්ලේ",
  "Film Artiste": "චිත්‍රපට ශිල්පියා",
  "First Letter of First Name": "මුල් නමේ පළමු අකුර",
  Fonseka: "ෆොන්සේකා",
  "G. G.": "ජී.ජී.",
  "G. G. Ponnambalam": "ජී.ජී.පොන්නම්බලම්",
  "G. L.": "ජී.එල්.",
  "G. L. Peiris": "ජී.එල්. පීරිස්",
  Galappaththi: "ගලප්පත්ති",
  Galle: "ගාල්ල",
  Gamage: "ගමගේ",
  Gamalath: "ගමලත්",
  Gamini: "ගාමිණී",
  "Gamini Lokuge": "ගාමිණී ලොකුගේ",
  "Gamini Waleboda": "ගාමිණී වලේබොඩ",
  Gammanpila: "ගම්මන්පිල",
  Gampaha: "ගම්පහ",
  Ganesan: "ගනේෂන් ය",
  Gayantha: "ගයන්ත",
  "Gayantha Karunatilleka": "ගයන්ත කරුණාතිලක",
  Gayashan: "ගයාෂාන්",
  "Gayashan Nawananda": "ගයාෂාන් නවානන්ද",
  "Geetha Samanmale": "ගීතා සමන්මලේ",
  "Geetha Samanmale Kumarasinghe": "ගීතා සමන්මලේ කුමාරසිංහ",
  Gender: "ස්ත්රී පුරුෂ භාවය",
  Generation: "පරම්පරාව",
  Gevindu: "ගෙවිඳු",
  "Gevindu Cumaratunga": "ගෙවිඳු කුමාරතුංග",
  Godahewa: "ගොඩහේවා",
  Govindan: "ගෝවින්දන්",
  "Govindan Karunakaram": "ගෝවින්දන් කරුණාකරම්",
  Gunathilaka: "ගුණතිලකය",
  "Gunathilaka Rajapaksha": "ගුණතිලක රාජපක්ෂ",
  Gunawardana: "ගුණවර්ධනය",
  Gunawardena: "ගුණවර්ධන ය",
  Gunawardene: "ගුණවර්ධන ය",
  "H.": "එච්.",
  "H. M. M.": "එච්. එම්. එම්.",
  "H. M. M. Harees": "එච්.එම්.එම්.හැරීස්",
  "H. Nandasena": "එච්.නන්දසේන",
  Hakeem: "හකීම් ය",
  Haleem: "හලීම් ය",
  Hambantota: "හම්බන්තොට",
  Harees: "හාරිස්",
  Harin: "හරීන්",
  "Harin Fernando": "හරීන් ප්‍රනාන්දු",
  Harini: "හරිනි",
  "Harini Amarasuriya": "හරිනි අමරසූරිය",
  Harsha: "හර්ෂ",
  "Harsha de Silva": "හර්ෂ ද සිල්වා",
  Harshana: "හර්ෂණ",
  "Harshana Rajakaruna": "හර්ෂණ රාජකරුණා",
  "Has A. Levels or higher?": "උසස් පෙළ හෝ ඊට වැඩිද?",
  "Has Advanced Levels or higher?": "උසස් පෙළ හෝ ඊට වැඩිද?",
  "Has Bachelors or higher?": "උපාධිය හෝ ඊට වැඩිද?",
  "Has Publicly Declared Assets?": "ප්‍රසිද්ධියේ ප්‍රකාශිත වත්කම් තිබේද?",
  Hashim: "හෂීම් ය",
  Hector: "හෙක්ටර්",
  "Hector Appuhamy": "හෙක්ටර් අප්පුහාමි",
  Help: "උදව්",
  Herath: "හේරත්",
  Hesha: "හේෂා",
  "Hesha Withanage": "හේෂා විතානගේ",
  "Highest Education Level": "ඉහළම අධ්‍යාපන මට්ටම",
  "Highly significantly fewer": "ඉතා සැලකිය යුතු ලෙස අඩුය",
  "Highly significantly more": "ඉතා සැලකිය යුතු ලෙස වැඩි",
  Hinduism: "හින්දු ආගම",
  "ISCED0 Unknown": "ISCED0 නොදන්නා",
  "ISCED1 Primary": "ISCED1 ප්‍රාථමික",
  "ISCED2 Lower Secondary (O. Levels)": "ISCED2 පහළ ද්විතියික (O. මට්ටම්)",
  "ISCED3 Upper Secondary (A. Levels)": "ISCED3 ඉහළ ද්විතියික (උසස් පෙළ)",
  "ISCED4 Post-Secondary": "ISCED4 පශ්චාත්-ද්විතියික",
  "ISCED6 Bachelors": "ISCED6 උපාධිය",
  "ISCED7 Masters": "ISCED7 මාස්ටර් උපාධිය",
  "ISCED8 Doctorate": "ISCED8 ආචාර්ය උපාධිය",
  ITAK: "ITAK",
  Imran: "ඉම්රාන්",
  "Imran Maharoof": "ඉම්රාන් මහරුෆ්",
  Imthiaz: "ඉමිතියාස්",
  "Imthiaz Bakeer Markar": "ඉමිතියාස් බාකීර් මාකර්",
  "Indika Anuruddha": "ඉන්දික අනුරුද්ධ",
  "Indika Anuruddha Herath": "ඉන්දික අනුරුද්ධ හේරත්",
  "Is Age > 40": "වයස අවුරුදු 40ට වැඩිය",
  "Is Age > 50": "වයස අවුරුදු 50ට වැඩිය",
  "Is National List?": "ජාතික ලැයිස්තුවද?",
  "Is Sinhala Buddhist?": "සිංහල බෞද්ධ ද?",
  Ishak: "ඉෂාක්",
  "Ishak Rahuman": "ඉෂාක් රහුමාන්",
  Islam: "ඉස්ලාම්",
  Isuru: "Isuru",
  "Isuru Dodangoda": "Isuru Dodangoda",
  "J. C.": "ජේ. සී.",
  "J. C. Alawathuwala": "ජේ සී අලවතුවල",
  JJB: "JJB",
  Jaffna: "යාපනය",
  Jagath: "ජගත්",
  "Jagath Kumara": "ජගත් කුමාර",
  "Jagath Kumara Sumithraarachchi": "ජගත් කුමාර සුමිත්‍රආරච්චි",
  "Jagath Pushpakumara": "ජගත් පුෂ්පකුමාර",
  "Jagath Samarawickrama": "ජගත් සමරවික්‍රම",
  Janaka: "ජානක",
  "Janaka Bandara": "ජනක බණ්ඩාර",
  "Janaka Bandara Thennakoon": "ජනක බණ්ඩාර තෙන්නකෝන්",
  "Janaka Wakkumbura": "Janaka Wakkumbura",
  Jayakody: "ජයකොඩි",
  Jayamaha: "ජයමහ",
  Jayantha: "ජයන්ත",
  "Jayantha Ketagoda": "ජයන්ත කැටගොඩ",
  "Jayantha Samaraweera": "ජයන්ත සමරවීර",
  "Jayantha Weerasinghe": "ජයන්ත වීරසිංහ",
  Jayarathna: "ජයරත්න",
  "Jayarathna Herath": "ජයරත්න හේරත්",
  Jayaratne: "ජයරත්න",
  Jayasekara: "ජයසේකර",
  Jayasumana: "ජයසුමන",
  Jayathilake: "ජයතිලක",
  Jayawardhana: "ජයවර්ධන",
  Jeevan: "ජීවන්",
  "Jeevan Thondaman": "ජීවන් තොණ්ඩමන්",
  John: "ජෝන්",
  "John Seneviratne": "ජෝන් සෙනෙවිරත්න",
  Johnston: "ජොන්ස්ටන්",
  "Johnston Fernando": "ජොන්ස්ටන් ප්‍රනාන්දු",
  Journalist: "මාධ්‍යවේදියා",
  "K. Kader": "කේ කාදර්",
  "K. Kader Masthan": "කේ කාදර් මස්තාන්",
  "K. P. S.": "කේ.පී.එස්.",
  "K. P. S. Kumarasiri": "K. P. S. කුමාරසිරි",
  "K. Sujith Sanjaya": "කේ සුජිත් සංජය",
  "K. Sujith Sanjaya Perera": "කේ.සුජිත් සංජය පෙරේරා",
  Kabir: "කබීර්",
  "Kabir Hashim": "කබීර් හෂීම්",
  Kajendren: "කජේන්ද්‍රන්",
  Kalutara: "කළුතර",
  Kanaka: "කනක",
  "Kanaka Herath": "කනක හේරත්",
  Kanchana: "කාංචනා",
  "Kanchana Wijesekera": "කාංචන විජේසේකර",
  Kandy: "මහනුවර",
  Kapila: "කපිල",
  "Kapila Athukorala": "කපිල අතුකෝරල",
  Kariyawasam: "කාරියවසම්",
  Karunadasa: "Karunadasa",
  "Karunadasa Kodithuwakku": "කරුණාදාස කොඩිතුවක්කු",
  Karunakaram: "කරුණාකරම්",
  Karunatilleka: "කරුණාතිලක",
  "Kavinda Heshan": "කාවින්ද හේෂාන්",
  "Kavinda Heshan Jayawardhana": "කාවින්ද හේෂාන් ජයවර්ධන",
  Kegalle: "කෑගල්ල",
  Keheliya: "කෙහෙළිය",
  "Keheliya Rambukwella": "කෙහෙළිය රඹුක්වැල්ල",
  Ketagoda: "කැටගොඩ",
  Kins: "ඥාතීන්",
  "Kins Nelson": "කින්ස් නෙල්සන්",
  Kiriella: "කිරිඇල්ල",
  Kirindigoda: "කිරිඳිගොඩ",
  Kodithuwakku: "කොඩිතුවක්කු",
  Kokila: "කෝකිලා",
  "Kokila Gunawardene": "කෝකිල ගුණවර්ධන",
  Kottegoda: "Kottegoda",
  Kulasingam: "කුලසිංහම් ය",
  "Kulasingam Dhileeban": "කුලසිංහම් දිලීබන්",
  Kumar: "කුමාර",
  Kumara: "කුමාර",
  "Kumara Welgama": "කුමාර වෙල්ගම",
  Kumarasinghe: "කුමාරසිංහ",
  Kumarasiri: "කුමාරසිරි ය",
  "Kumarasiri Rathnayaka": "කුමාරසිරි රත්නායක",
  Kurunegala: "කුරුණෑගල",
  Lakshman: "ලක්ෂ්මන්",
  "Lakshman Kiriella": "ලක්ෂ්මන් කිරිඇල්ල",
  Lalith: "ලලිත්",
  "Lalith Ellawala": "ලලිත් එල්ලාවල",
  "Lalith Varna": "ලලිත් වර්ණ",
  "Lalith Varna Kumara": "ලලිත් වර්ණ කුමාර",
  "Landed Proprietor": "ඉඩම් හිමිකරු",
  Lanza: "ලංසා",
  Lasantha: "ලසන්ත",
  "Lasantha Alagiyawanna": "ලසන්ත අලගියවන්න",
  "Last Name": "අවසන් නම",
  Lecturer: "කථිකාචාර්ය",
  "Left to Right": "වමේ සිට දකුණට",
  "Legal Advisor": "නීති උපදේශක",
  Liyanage: "ලියනගේ ය",
  Lohan: "ලොහාන්",
  "Lohan Ratwatte": "ලොහාන් රත්වත්තේ",
  Lokuge: "ලොකුගේ",
  "M .U. M.": "එම් .යූ. එම්.",
  "M .U. M. Ali Sabry": "එම් .යූ. එම්. අලි සබ්රි",
  "M.": "එම්.",
  "M. A.": "එම්. ඒ.",
  "M. A. Sumanthiran": "එම් ඒ සුමන්තිරන්",
  "M. Rameshwaran": "එම් රාමේෂ්වරන්",
  "M. S.": "මෙනෙවිය.",
  "M. S. Thowfeek": "M. S. තව්ෆීක්",
  "M. Udayakumar": "එම් උදයකුමාර්",
  "M. W. D. Sahan Pradeep": "M. W. D. සහන් ප්‍රදීප්",
  "M. W. D. Sahan Pradeep Withana": "M. W. D. සහන් ප්‍රදීප් විතාන",
  MNA: "MNA",
  Madhura: "මධුර",
  "Madhura Withanage": "මධුර විතානගේ",
  Maharoof: "මහරුෆ්",
  Mahinda: "මහින්ද",
  "Mahinda Amaraweera": "මහින්ද අමරවීර",
  "Mahinda Rajapaksa": "මහින්ද රාජපක්ෂ",
  "Mahinda Yapa": "මහින්ද යාපා",
  "Mahinda Yapa Abeywardana": "මහින්ද යාපා අබේවර්ධන",
  Mahindananda: "මහින්දානන්ද",
  "Mahindananda Aluthgamage": "මහින්දානන්ද අලුත්ගමගේ",
  Maithreepala: "මෛත්‍රීපාල",
  "Maithreepala Sirisena": "මෛත්‍රීපාල සිරිසේන",
  "Major Pradeep Undugoda": "මේජර් ප්‍රදීප් උඳුගොඩ",
  Male: "පිරිමි",
  Manjula: "මංජුල",
  "Manjula Dissanayake": "මංජුල දිසානායක",
  Mannapperuma: "Mannapperuma",
  Mano: "මනෝ",
  "Mano Ganesan": "Mano Ganesan",
  Manusha: "මනූෂා",
  "Manusha Nanayakkara": "මනූෂ නානායක්කාර",
  Marikkar: "මරික්කාර්",
  Marjan: "මර්ජන්",
  "Marjan Faleel": "මර්ජන් ෆලීල්",
  Married: "විවාහකයි",
  Masthan: "මස්තාන්",
  Matale: "මාතලේ",
  Matara: "මාතර",
  "Mayadunna Chinthaka": "මායාදුන්න චින්තක",
  "Mayadunna Chinthaka Amal": "මායාදුන්න චින්තක අමල්",
  Mayantha: "මයන්ත",
  "Mayantha Dissanayake": "මයන්ත දිසානායක",
  "Medical Consultant - Specialist.": "වෛද්ය උපදේශක - විශේෂඥ.",
  "Medical Practitioner": "වෛද්‍ය වෘත්තිකයා",
  "Medical Practitioner; Academician": "වෛද්ය වෘත්තිකයා; ශාස්ත්රාලිකයා",
  Milan: "මිලාන්",
  "Milan Jayathilake": "මිලාන් ජයතිලක",
  "Miscellaneous & Fun": "විවිධ සහ විනෝදය",
  "Mohan Priyadarshana": "මොහාන් ප්‍රියදර්ශන",
  "Mohan Priyadarshana De Silva": "මොහාන් ප්‍රියදර්ශන ද සිල්වා",
  Mohomad: "මොහොමඩ්",
  "Mohomad Muzammil": "මොහොමඩ් මුසම්මිල්",
  Moneragala: "මොණරාගල",
  "Month of Birth": "උපන් මාසය",
  "Most Popular": "වඩාත්ම ජනප්රියයි",
  Muditha: "මුදිතා",
  "Muditha Prishanthi": "මුදිතා ප්‍රිශාන්ති",
  Mujibur: "මුජිබර්",
  "Mujibur Rahuman": "මුජිබර් රහුමාන්",
  Muszhaaraff: "මුෂාරෆ්",
  Muzammil: "මුසම්මිල්",
  NC: "NC",
  Nalaka: "නාලක",
  "Nalaka Bandara": "නාලක බණ්ඩාර",
  "Nalaka Bandara Kottegoda": "නාලක බණ්ඩාර කෝට්ටේගොඩ",
  "Nalaka Godahewa": "නාලක ගොඩහේවා",
  Nalin: "නලින්",
  "Nalin Bandara": "නලින් බණ්ඩාර",
  "Nalin Bandara Jayamaha": "නලින් බණ්ඩාර ජයමහ",
  "Nalin Fernando": "නලින් ප්‍රනාන්දු",
  Namal: "නාමල්",
  "Namal Rajapaksa": "නාමල් රාජපක්ෂ",
  Nanayakkara: "Nanayakkara",
  Nandasena: "නන්දසේන",
  Naseer: "නසීර්",
  "Naseer Ahamed": "නසීර් අහමඩ්",
  "National List": "ජාතික ලැයිස්තුව",
  Navarathna: "නවරත්න",
  Nawananda: "නවානන්ද",
  Nelson: "නෙල්සන්",
  Nimal: "නිමල්",
  "Nimal Lanza": "නිමල් ලාන්සා",
  "Nimal Piyathissa": "නිමල් පියතිස්ස",
  "Nimal Siripala": "නිමල් සිරිපාල",
  "Nimal Siripala de Silva": "නිමල් සිරිපාල ද සිල්වා",
  Nipuna: "නිපුන",
  "Nipuna Ranawaka": "නිපුන රණවක",
  Nirmalanathan: "නිර්මලනාදන්",
  Niroshan: "නිරෝෂන්",
  "Niroshan Perera": "නිරෝෂන් පෙරේරා",
  Nishantha: "නිශාන්ත",
  "No Data": "දත්ත නැත",
  Noharathalingam: "නොහාරතලිංගම්",
  None: "කිසිවක් නැත",
  "North Central": "උතුරු මැද",
  "North Western": "වයඹ",
  Northern: "උතුරු",
  "Not Declared": "ප්‍රකාශ කර නැත",
  "Not Sinhala Buddhist": "සිංහල බෞද්ධ නොවේ",
  "Not Sitting": "වාඩි වී නැත",
  "Number of Cabinets (since 2019 Nov)": "කැබිනට් සංඛ්‍යාව (2019 නොවැම්බර් සිට)",
  "Nuwara-Eliya": "නුවරඑළිය",
  OPPP: "OPPP",
  "Other or Unknown": "වෙනත් හෝ නොදන්නා",
  Palani: "පලනි",
  "Palani Thigambaram": "පලනි තිගාම්බරම්",
  "Parliament Website": "පාර්ලිමේන්තු වෙබ් අඩවිය",
  "Parliament of Sri Lanka": "ශ්‍රී ලංකා පාර්ලිමේන්තුව",
  Parliamentarian: "පාර්ලිමේන්තු මන්ත්‍රී",
  Party: "පක්ෂය",
  Pasqual: "පැස්කුවල්",
  "Patali Champika": "පාඨලී චම්පික",
  "Patali Champika Ranawaka": "පාඨලී චම්පික රණවක",
  Pathirana: "පතිරණ",
  Pavithradevi: "පවිත්‍රාදේවි",
  "Pavithradevi Wanniarachchi": "පවිත්‍රාදේවි වන්නිආරච්චි",
  Peiris: "පීරිස්",
  Perera: "පෙරේරා",
  "Pharmacutical Distributor": "ඖෂධ බෙදාහරින්නා",
  Phone: "දුරකථන",
  "Phone Sitting": "දුරකථනය වාඩි වී සිටීම",
  "Piyal Nishantha": "පියල් නිශාන්ත",
  "Piyal Nishantha De Silva": "පියල් නිශාන්ත ද සිල්වා",
  Piyankara: "පියංකර",
  "Piyankara Jayaratne": "පියංකර ජයරත්න",
  Piyathissa: "පියතිස්ස",
  Planter: "වැවිලිකරු",
  "Planter; Businessman": "වැවිලිකරු; ව්යාපාරිකයා",
  "Political Parties": "දේශපාලන පක්ෂ",
  "Political Parties & Electoral Regions": "දේශපාලන පක්ෂ සහ මැතිවරණ කලාප",
  Politician: "දේශපාලනඥයා",
  Polonnaruwa: "පොළොන්නරුව",
  Ponnambalam: "පොන්නම්බලම්",
  Pradeep: "ප්‍රදීප්",
  "Pradeep Undugoda": "ප්‍රදීප් උඳුගොඩ",
  Prasanna: "ප්‍රසන්න",
  "Prasanna Ranatunga": "ප්‍රසන්න රණතුංග",
  "Prasanna Ranaweera": "ප්‍රසන්න රණවීර",
  Premadasa: "ප්‍රේමදාස ය",
  Premajayantha: "ප්‍රේමජයන්ත",
  Premalal: "ප්‍රේමලාල්",
  "Premalal Jayasekara": "ප්‍රේමලාල් ජයසේකර",
  Premarathne: "ප්‍රේමරත්න",
  "Premitha Bandara": "ප්‍රේමිත බණ්ඩාර",
  "Premitha Bandara Tennakoon": "ප්‍රේමිත බණ්ඩාර තෙන්නකෝන්",
  "Premnath C.": "ප්‍රේම්නාත් සී.",
  "Premnath C. Dolawatte": "ප්‍රේම්නාත් සී දොලවත්ත",
  Prishanthi: "ප්‍රිශාන්ති",
  Priyantha: "ප්‍රියන්ත",
  Profession: "වෘත්තිය",
  "Professional Qualifications": "වෘත්තීය සුදුසුකම්",
  "Profile Article": "පැතිකඩ ලිපිය",
  "Profile Page": "පැතිකඩ පිටුව",
  Province: "පළාත",
  Pushpakumara: "පුෂ්පකුමාර",
  Puttalam: "පුත්තලම",
  "R. M. Ranjith Madduma": "R. M. රංජිත් මද්දුම",
  "R. M. Ranjith Madduma Bandara": "R. M. රංජිත් මද්දුම බණ්ඩාර",
  Radhakrishnan: "රාධක්‍රිෂ්ණන්",
  Raghavan: "රාඝවන් ය",
  Raheem: "රහීම් ය",
  Rahuman: "රහුමාන්",
  Rajakaruna: "රාජකරුණා ය",
  Rajapaksa: "රාජපක්ෂ",
  Rajapakse: "රාජපක්ෂ",
  Rajapaksha: "රාජපක්ෂ",
  Rajapakshe: "රාජපක්ෂ",
  Rajavarothiam: "රාජවරෝතියම්",
  "Rajavarothiam Sampanthan": "රාජවරෝතියම් සම්බන්ධන්",
  Rajika: "Rajika",
  "Rajika Wickramasinghe": "රාජිකා වික්‍රමසිංහ",
  Rajitha: "රාජිත",
  "Rajitha Senarathne": "රාජිත සේනාරත්න",
  Ramanathan: "රාමනාදන්",
  Rambukwella: "රඹුක්වැල්ල",
  Ramesh: "රමේෂ්",
  "Ramesh Pathirana": "රමේෂ් පතිරණ",
  Rameshwaran: "රාමේෂ්වරන්",
  Ranasinghe: "රණසිංහ",
  Ranatunga: "රණතුංග ය",
  Ranawaka: "රණවක",
  Ranaweera: "රණවීර",
  "Random MP": "අහඹු මන්ත්‍රී",
  Ranil: "රනිල්",
  "Ranil Wickremesinghe": "රනිල් වික්‍රමසිංහ",
  Ranjith: "රංජිත්",
  "Ranjith Bandara": "රංජිත් බණ්ඩාර",
  "Ranjith Siyambalapitiya": "රංජිත් සියඹලාපිටිය",
  Rasamanickam: "රසමානික්කම්",
  Rathana: "රතන",
  Rathnasekara: "රත්නසේකර",
  Rathnayaka: "රත්නායක",
  Rathnayake: "රත්නායක",
  Ratnapura: "රත්නපුරය",
  Ratwatte: "රත්වත්තේ",
  Rauff: "රවුෆ්",
  "Rauff Hakeem": "රවුෆ් හකීම්",
  Religion: "ආගම",
  "Religion & Ethnicity": "ආගම සහ වාර්ගිකත්වය",
  Rishad: "රිෂාඩ්",
  "Rishad Bathiudeen": "රිෂාඩ් බදියුදීන්",
  Rohana: "රෝහණ",
  "Rohana Bandara": "රෝහණ බණ්ඩාර",
  "Rohana Dissanayaka": "රෝහණ දිසානායක",
  "Rohini Kumari": "Rohini Kumari",
  "Rohini Kumari Wijerathna": "රෝහිණී කුමාරි විජේරත්න",
  Rohitha: "රෝහිත",
  "Rohitha Abegunawardhana": "රෝහිත අබේගුණවර්ධන",
  Roshan: "රොෂාන්",
  "Roshan Ranasinghe": "රොෂාන් රණසිංහ",
  "S.": "එස්.",
  "S. B.": "එස්. බී.",
  "S. B. Dissanayake": "එස් බී දිසානායක",
  "S. M.": "එස්. එම්.",
  "S. M. Chandrasena": "එස් එම් චන්ද්‍රසේන",
  "S. M. M.": "එස්. එම්. එම්.",
  "S. M. M. Muszhaaraff": "එස්. එම්. එම්. මුෂාරෆ්",
  "S. M. Marikkar": "එස්.එම් මරික්කාර්",
  "S. Noharathalingam": "එස් නොහාරතලිංගම්",
  "S. Viyalanderan": "එස් වියාලන්දරන්",
  SJB: "එස්.ජේ.බී",
  SLFP: "ශ්‍රීලනිප",
  SLMC: "SLMC",
  SLPP: "SLPP",
  Sabaragamuwa: "සබරගමුව",
  Sagara: "සාගර",
  "Sagara Kariyawasam": "සාගර කාරියවසම්",
  Sajith: "සජිත්",
  "Sajith Premadasa": "සජිත් ප්‍රේමදාස",
  Samanpriya: "සමන්ප්‍රිය",
  "Samanpriya Herath": "සමන්ප්‍රිය හේරත්",
  Samaraweera: "සමරවීර",
  Sampanthan: "සම්බන්ධන්",
  Sampath: "සම්පත්",
  "Sampath Athukorala": "සම්පත් අතුකෝරල",
  Sanath: "සනත්",
  "Sanath Nishantha": "සනත් නිශාන්ත",
  Sanjeeva: "සංජීව",
  "Sanjeeva Edirimanna": "සංජීව එදිරිමාන්න",
  Santhirakanthan: "ශාන්තිරකාන්තන්",
  Sarath: "සරත්",
  "Sarath Fonseka": "සරත් ෆොන්සේකා",
  "Sarath Weerasekera": "සරත් වීරසේකර",
  Sarathi: "සාරතී",
  "Sarathi Dushmantha": "සාරතී දුෂ්මන්ත",
  Seetha: "සීතා",
  "Seetha Arambepola": "සීතා අරඹේපොල",
  Selvam: "සෙල්වම්",
  "Selvam Adaikkalanathan": "සෙල්වම් අඩෛක්කලනාදන්",
  Selvarajah: "සෙල්වරාජා",
  "Selvarajah Kajendren": "සෙල්වරාජා කජේන්ද්‍රන්",
  Semasinghe: "සේමසිංහ",
  Senarathne: "සේනාරත්න ය",
  Seneviratne: "සෙනෙවිරත්න",
  "Shan Vijayalal": "ශාන් විජයලාල්",
  "Shan Vijayalal De Silva": "ශාන් විජයලාල් ද සිල්වා",
  "Shanakiyan Rajaputhiran": "ශානකියන් රාජපුතීරන්",
  "Shanakiyan Rajaputhiran Rasamanickam": "ශානකියන් රාජපුතීරන් රසමානික්කම්",
  Shantha: "ශාන්තය",
  "Shantha Bandara": "ශාන්ත බණ්ඩාර",
  Shasheendra: "ශෂීන්ද්‍ර",
  "Shasheendra Rajapaksa": "ශෂීන්ද්‍ර රාජපක්ෂ",
  Shehan: "ෂෙහාන්",
  "Shehan Semasinghe": "ෂෙහාන් සේමසිංහ",
  "Show All": "සියල්ල පෙන්වන්න",
  "Show Random": "අහඹු ලෙස පෙන්වන්න",
  "Show Random MP": "අහඹු මන්ත්‍රී පෙන්වන්න",
  "Show Statistical Trends": "සංඛ්‍යාන ප්‍රවණතා පෙන්වන්න",
  Shritharan: "ශ්‍රීදරන්",
  "Significantly fewer": "සැලකිය යුතු ලෙස අඩුය",
  "Significantly more": "සැලකිය යුතු ලෙස වැඩි",
  Single: "තනි",
  "Sinhala Buddhist": "සිංහල බෞද්ධ",
  Siripala: "සිරිපාල",
  "Siripala Gamalath": "සිරිපාල ගමලත්",
  Sirisena: "සිරිසේන",
  Sisira: "සිසිර",
  "Sisira Jayakody": "සිසිර ජයකොඩි",
  Sithadthan: "සිතදතං",
  Sitting: "වාඩි වී සිටීම",
  Sivagnanam: "සිවඥානම්",
  "Sivagnanam Shritharan": "සිවඥානම් ශ්‍රීදරන්",
  Sivanesathurai: "සිවනේෂතුරෙයි",
  "Sivanesathurai Santhirakanthan": "සිවනේසතුරෙයි ශාන්තිරකාන්තන්",
  Siyambalapitiya: "සියඹලාපිටිය",
  "Slightly fewer": "ටිකක් අඩුයි",
  "Slightly more": "තව ටිකක්",
  Southern: "දකුණු",
  "Stated Profession": "ප්රකාශිත වෘත්තිය",
  "Statistical Trends": "සංඛ්යානමය ප්රවණතා",
  "Statistical Trends measure if certain grid cells contain more MPs than we would expect if they were assigned at random.": "සංඛ්‍යානමය ප්‍රවණතා මනිනු ලබන්නේ ඇතැම් ජාල සෛල අහඹු ලෙස පවරනු ලැබුවහොත් අප බලාපොරොත්තු වන ප්‍රමාණයට වඩා මන්ත්‍රීවරුන් සංඛ්‍යාවක් අඩංගුද යන්නයි.",
  "Statistical Trends measure if certain grid cells contain more MPs than we would expect if they were assigned at random.  The 'z' (e.g. z = 2.5) value shows how many standard deviations the number of MPs vary from the mean number of expected MPs. The range (e.g. 84 - 114) is the 95% confidence interval for the number of MPs. If the actual number is outside this range, the probability that the trend is random is <5%.": "සංඛ්‍යානමය ප්‍රවණතා මනිනු ලබන්නේ ඇතැම් ජාල සෛල අහඹු ලෙස පවරනු ලැබුවහොත් අප බලාපොරොත්තු වන ප්‍රමාණයට වඩා මන්ත්‍රීවරුන් සංඛ්‍යාවක් අඩංගුද යන්නයි. 'z' (උදා. z = 2.5) අගය පෙන්නුම් කරන්නේ මන්ත්‍රීවරුන් සංඛ්‍යාව අපේක්ෂිත මන්ත්‍රීවරුන්ගේ මධ්‍යන්‍ය සංඛ්‍යාවෙන් කොපමණ සම්මත අපගමන සංඛ්‍යාවක් වෙනස් වේද යන්නයි. පරාසය (උදා. 84 - 114) යනු මන්ත්‍රීවරුන් සංඛ්‍යාව සඳහා 95% විශ්වාසනීය පරතරයයි. සත්‍ය සංඛ්‍යාව මෙම පරාසයෙන් පිටත නම්, ප්‍රවණතාවය අහඹු වීමේ සම්භාවිතාව <5% වේ.",
  Sudarshana: "සුදර්ශන",
  "Sudarshana Denipitiya": "සුදර්ශන දෙනිපිටිය",
  Sudarshini: "සුදර්ශිනී",
  "Sudarshini Fernandopulle": "සුදර්ශිනී ප්‍රනාන්දුපුල්ලේ",
  Sudath: "සුදත්",
  "Sudath Manjula": "සුදත් මංජුල",
  Sumanthiran: "සුමන්තිරන්",
  Sumithraarachchi: "සුමිත්‍රආරච්චි",
  Suren: "සුරේන්",
  "Suren Raghavan": "සුරේන් රාඝවන්",
  Suresh: "සුරේෂ්",
  Susil: "සුසිල්",
  "Susil Premajayantha": "සුසිල් ප්‍රේමජයන්ත",
  TMTK: "TMTK",
  TMVP: "ටීඑම්වීපී",
  Teacher: "ගුරු",
  Tennakoon: "තෙන්නකෝන් ය",
  Thalatha: "තලතා",
  "Thalatha Athukorala": "තලතා අතුකෝරල",
  Tharaka: "තාරකා",
  "Tharaka Balasuriya": "තාරක බාලසූරිය",
  "Thavaraja Kalai": "තවරාජා කලායි",
  "Thavaraja Kalai Arasan": "තවරාජා කලයි අරසන්",
  "The 'z' (e.g. z = 2.5) value shows how many standard deviations the number of MPs vary from the mean number of expected MPs.": "'z' (උදා. z = 2.5) අගය පෙන්නුම් කරන්නේ මන්ත්‍රීවරුන් සංඛ්‍යාව අපේක්ෂිත මන්ත්‍රීවරුන්ගේ මධ්‍යන්‍ය සංඛ්‍යාවෙන් කොපමණ සම්මත අපගමන සංඛ්‍යාවක් වෙනස් වේද යන්නයි.",
  "The Parliament of Sri Lanka": "ශ්‍රී ලංකා පාර්ලිමේන්තුව",
  "The range (e.g. 84 - 114) is the 95% confidence interval for the number of MPs. If the actual number is outside this range, the probability that the trend is random is <5%.": "පරාසය (උදා. 84 - 114) යනු මන්ත්‍රීවරුන් සංඛ්‍යාව සඳහා 95% විශ්වාසනීය පරතරයයි. සත්‍ය සංඛ්‍යාව මෙම පරාසයෙන් පිටත නම්, ප්‍රවණතාවය අහඹු වීමේ සම්භාවිතාව <5% වේ.",
  Thennakoon: "තෙන්නකෝන් ය",
  Thenuka: "තේනුක",
  "Thenuka Vidanagamage": "තේනුක විදානගමගේ",
  Thigambaram: "තිගාම්බරම්",
  Thilak: "තිලක්",
  "Thilak Rajapakshe": "තිලක් රාජපක්ෂ",
  Thisakutti: "තිස්කුට්ටි",
  "Thisakutti Arachchi": "තිස්කුට්ටි ආරච්චි",
  Thondaman: "තොණ්ඩමන්",
  Thowfeek: "තව්ෆීක්",
  "Thushara Indunil": "තුෂාර ඉඳුනිල්",
  "Thushara Indunil Amarasena": "තුෂාර ඉඳුනිල් අමරසේන",
  Tiran: "ටිරාන්",
  "Tiran Alles": "ටිරාන් අලස්",
  Tissa: "තිස්ස",
  "Tissa Attanayake": "තිස්ස අත්තනායක",
  "Tissa Vitarana": "තිස්ස විතාරණ",
  "Top to Bottom": "ඉහළ සිට පහළට",
  "Trade Unionist": "වෘත්තීය සමිතිවාදියෙක්",
  "Trained Teacher": "පුහුණු ගුරුවරයා",
  "Transparency & Corruption": "විනිවිදභාවය සහ දූෂණය",
  Trincomalee: "ත්රිකුණාමලය",
  "U. K. Sumith": "යූ කේ සුමිත්",
  "U. K. Sumith Udukumbura": "U. K. සුමිත් උඩුකුඹුර",
  UNP: "එජාප",
  Udaya: "උදය",
  "Udaya Gammanpila": "උදය ගම්මන්පිල",
  Udayakantha: "උදයකාන්ත",
  "Udayakantha Gunathilaka": "උදයකාන්ත ගුණතිලක",
  Udayakumar: "උදයකුමාර්",
  Udayana: "උදයන",
  "Udayana Kirindigoda": "උදයන කිරිඳිගොඩ",
  Uddika: "උද්දික",
  "Uddika Premarathne": "උද්දික ප්‍රේමරත්න",
  Udukumbura: "උඩුකුඹුර",
  Undo: "අහෝසි කරන්න",
  "Undo last action": "අවසාන ක්‍රියාව අස් කරන්න",
  Undugoda: "උඳුගොඩ",
  "University Lecturer": "විශ්වවිද්‍යාල කථිකාචාර්ය",
  Upul: "උපුල්",
  "Upul Galappaththi": "උපුල් ගලප්පත්ති",
  "Upul Mahendra": "උපුල් මහේන්ද්‍ර",
  "Upul Mahendra Rajapaksha": "උපුල් මහේන්ද්‍ර රාජපක්ෂ",
  "Use Statistical Trends": "සංඛ්‍යාන ප්‍රවණතා භාවිතා කරන්න",
  Uva: "ඌව",
  "V.": "වී.",
  "V. Radhakrishnan": "වී රාධක්‍රිෂ්ණන්",
  Vadivel: "වඩිවෙල්",
  "Vadivel Suresh": "වඩිවෙල් සුරේෂ්",
  Vanni: "වන්නිය",
  Vasudeva: "වාසුදේව",
  "Vasudeva Nanayakkara": "වාසුදේව නානායක්කාර",
  Velu: "වේලු",
  "Velu Kumar": "වේලු කුමාර",
  Vidanagamage: "විදානගමගේ",
  Vidura: "විදුර",
  "Vidura Wickramanayaka": "විදුර වික්‍රමනායක",
  Vijitha: "විජිත",
  "Vijitha Berugoda": "විජිත බේරුගොඩ",
  "Vijitha Herath": "විජිත හේරත්",
  "Visualization, Design and App by @nuuuwan": "@nuuuwan විසින් දෘශ්‍යකරණය, නිර්මාණය සහ යෙදුම",
  Vitarana: "විතාරණ",
  Viyalanderan: "වියලන්දෙරන්",
  "Vote for 20th Amendment": "20 වැනි සංශෝධනයට ඡන්දය දීම",
  "Voted Against": "විරුද්ධව ඡන්දය දුන්නා",
  "Voted: In Favour": "පක්ෂව ඡන්දය දුන්නා",
  "Voting & Parliamentary Attandance": "ඡන්දය සහ පාර්ලිමේන්තු පැමිණීම",
  "Voting & Parliamentary Participation": "ඡන්දය සහ පාර්ලිමේන්තු සහභාගීත්වය",
  "Voting Record": "ඡන්ද වාර්තාව",
  "Voting for 20th Amendment": "20 වැනි සංශෝධනයට ඡන්දය දීම",
  "Voting for 22nd Amendment": "22 වැනි සංශෝධනයට ඡන්දය දීම",
  "W. H. M.": "ඩබ්ලිව්.එච්.එම්.",
  "W. H. M. Dharmasena": "ඩබ්ලිව්.එච්.එම් ධර්මසේන",
  "Wajira Abeywardana": "වජිර අබේවර්ධන",
  Wakkumbura: "වක්කුඹුර",
  Waleboda: "වලේබොඩ",
  Wanniarachchi: "වන්නිආරච්චි",
  Waruna: "Waruna",
  "Waruna Liyanage": "වරුණ ලියනගේ",
  "Was in 2019 Nov Cabinet?": "2019 නොවැ කැබිනට් එකේද?",
  "Was in 2020 Aug Cabinet?": "2020 අගෝස්තුවේ කැබිනට් මණ්ඩලයද?",
  "Was in 2022 Apr Cabinet?": "2022 අප්‍රේල් කැබිනට් එකේද?",
  "Was in 2022 May Cabinet?": "2022 මැයි මාසයේ කැබිනට් මණ්ඩලය තිබුණාද?",
  Wasantha: "වසන්ත",
  "Wasantha Yapabandara": "වසන්ත යාපබණ්ඩාර",
  Wedaarachchi: "වෙදආරච්චි",
  Weerakkody: "වීරක්කොඩි",
  Weerasekera: "වීරසේකර",
  Weerasingha: "වීරසිංහ",
  Weerasinghe: "වීරසිංහ",
  Weerasumana: "වීරසුමන",
  "Weerasumana Weerasinghe": "වීරසුමන වීරසිංහ",
  Weerawansa: "වීරවංශ",
  Welgama: "වෙල්ගම",
  Western: "බටහිර",
  "What are Statistical Trends?": "සංඛ්‍යාන ප්‍රවණතා මොනවාද?",
  "When attending parliament": "පාර්ලිමේන්තුවට යනකොට",
  "When not attending parliament": "පාර්ලිමේන්තුවට නොපැමිණෙන විට",
  Wickramanayaka: "වික්‍රමනායක",
  Wickramaratne: "වික්‍රමරත්න",
  Wickramasinghe: "වික්‍රමසිංහ",
  Wickremesinghe: "වික්‍රමසිංහ",
  Widow: "වැන්දඹුව",
  Widower: "වැන්දඹුව",
  Wigneswaran: "විග්නේෂ්වරන්",
  Wijerathna: "විජේරත්න",
  Wijesekera: "විජේසේකර",
  Wijesiri: "විජේසිරි",
  Wijeyadasa: "විජයදාස ය",
  "Wijeyadasa Rajapakshe": "විජයදාස රාජපක්ෂ",
  Wikipedia: "විකිපීඩියා",
  Wimal: "විමල්",
  "Wimal Weerawansa": "විමල් වීරවංශ",
  Wimalaweera: "විමලවීර",
  "Wimalaweera Dissanayake": "විමලවීර දිසානායක",
  Withana: "විතාන",
  Withanage: "විතානගේ",
  Yadamini: "යදාමිනි",
  "Yadamini Gunawardena": "යදාමිණි ගුණවර්ධන",
  Yapa: "යාපා",
  Yapabandara: "Yapabandara",
  years: "වසර",
};
export default SINHALA_DICTIONARY;